import { SingleExecutionHelper } from 'cadenza/api-client/abort-controller/single-execution-helper';
import { ajax } from 'cadenza/api-client/api';
import type { ConditionApiOptions } from 'cadenza/api-client/conditions/condition-api';
import { ConditionApi } from 'cadenza/api-client/conditions/condition-api';
import type { TableDataDto } from 'cadenza/ui/base-table/model/table-data-dto';
import type { TableCellValue } from 'cadenza/ui/base-table/model/table-row-dto';
import type { BaseTableAjaxRequestParams } from 'cadenza/ui/base-table/base-table';

export class TableConditionApi extends ConditionApi {

  readonly #endpoint;
  #getConditionTableExecutionHelper = new SingleExecutionHelper();

  constructor (options: ConditionApiOptions, endpoint = '/tableConditionQuery') {
    super(options);
    this.#endpoint = endpoint;
  }

  override setValue (selectedRows: unknown[][]) {
    return super.setValue(selectedRows);
  }

  override async getValue (): Promise<TableCellValue[][]> {
    const res = await super.getValue();
    return (res as TableDataDto).rows.map(row => row.values);
  }

  getConditionTable (options: BaseTableAjaxRequestParams): Promise<TableDataDto> {
    if (Array.isArray(options.filterByColumn)) {
      options = Object.assign({}, options, {
        filterByColumn: options.filterByColumn.join()
      });
    }
    const abortController = new AbortController();
    this.#getConditionTableExecutionHelper.submit(abortController);
    return ajax(this.#endpoint, { data: { ...options, ...this.conditionQueryParams }, signal: abortController.signal });
  }

}
